import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<GenerateLinkResponse, Body>({
    query: (payload) => ({
      url: `/v5/link/generate`,
      method: 'POST',
      body: payload,
    }),
  });

type Body = {
  target_type: LinkType;
  target_id?: string;
};

export type GenerateLinkResponse = {
  data: {
    url: string;
    message: string;
  };
  code: number;
};

export enum LinkType {
  STADIUM = 'stadium',
  TOURNAMENT = 'tournament',
  CUSTOM = 'custom',
  VIDEOS = 'videos',
  LEADERBOARD = 'leaderboard',
  PADEL_MATCH = 'padel_match_model',
  MATCH_MODEL = 'match_model',
  USER_PROFILE = 'user_profile',
  MALAEB_LIVE = 'videos',
}
